import type { ApiClient } from '../client';
import {
  RoleAssignmentsResponseSchema,
  type RoleAssignmentsResponse,
  type RoleAssignmentWrite,
} from '../schemas/roleAssignments';

// One resource for the read and both writes. A person's email always travels in the body, never in
// the path, so it stays out of access logs and browser history.
const ASSIGNMENTS_PATH = '/app_service/panel/v1/access/assignments';

export async function fetchRoleAssignments(client: ApiClient): Promise<RoleAssignmentsResponse> {
  const data = await client.get<unknown>(ASSIGNMENTS_PATH);
  return RoleAssignmentsResponseSchema.parse(data);
}

// Create (expectedVersion null) or replace one person's whole Asignación. `expected_version` is
// always sent: the server refuses a body without it rather than skipping the version check. The
// 200 carries the new version, which the screen does not use: it re-reads the list.
export async function upsertRoleAssignment(client: ApiClient, write: RoleAssignmentWrite): Promise<void> {
  await client.post(ASSIGNMENTS_PATH, {
    email: write.email,
    expected_version: write.expectedVersion,
    roles: write.roles,
    extra_permissions: write.extraPermissions,
  });
}

// «Quitar todo» is its own explicit operation, never an upsert with empty lists: it also removes
// the roles and extras the panel does not manage.
export async function removeAllRoleAssignment(
  client: ApiClient,
  email: string,
  expectedVersion: string,
): Promise<void> {
  await client.post(ASSIGNMENTS_PATH, { email, expected_version: expectedVersion, remove_all: true });
}
